import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../components/Header";

const BlogPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get("https://newsdata.io/api/1/news", {
          params: {
            apikey: "pub_45985b4ea3a66950665c6b9275c9b0a938e52",
            q: "energy OR sustainability OR renewable",
            language: "en",
            country: "us",
          },
        });
        setArticles(response.data.results);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching articles:", error);
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <main className="bg-[#01579b] text-white flex flex-col">
      <Header />
      <div className="w-[90%] mx-auto py-12">
        <h1 className="text-4xl md:text-6xl text-[#f46524] mb-8">
          Blogs & News
        </h1>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <div
                key={index}
                className="bg-white text-black p-6 rounded-md shadow-lg"
              >
                <img
                  src={
                    article.image_url ||
                    `https://via.placeholder.com/600/${Math.floor(
                      Math.random() * 1000
                    )}`
                  }
                  alt={article.title}
                  className="w-full h-48 object-cover mb-4 rounded-md"
                />
                <h2 className="text-xl font-semibold mb-2">{article.title}</h2>
                <p className="text-gray-700 mb-4">
                  {article.description
                    ? article.description.substring(0, 100)
                    : "No description available"}
                  ...
                </p>
                <a
                  href={article.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  Read More
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default BlogPage;
